import { render, staticRenderFns } from "./PopupCompanyInfo.vue?vue&type=template&id=55a4dc54&scoped=true"
import script from "./PopupCompanyInfo.vue?vue&type=script&lang=js"
export * from "./PopupCompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./PopupCompanyInfo.vue?vue&type=style&index=0&id=55a4dc54&prod&lang=scss&scoped=true"
import style1 from "./PopupCompanyInfo.vue?vue&type=style&index=1&id=55a4dc54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4dc54",
  null
  
)

export default component.exports